import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PageNotification, PageNotificationLocation } from '../models/page-notification';
import { Observable, throwError, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PageNotificationService {

  constructor(private api: ApiService) { }

  get(locations: PageNotificationLocation[]): Observable<PageNotification[]> {
    return this.api.get(`{
      pageNotifications(locations: [${locations.join(', ')}]){
          id
          lastChange
          type
          closable
          locations
          content
        }
      }`).pipe(
      switchMap(response => {
        if (response['error']) {
          return throwError(response);
        }

        return of(response['data']['pageNotifications']);
      }),
      this.api.unifyErrors()
    );
  }

  close(id: string): Observable<boolean> {
    return this.api.get(`mutation{
      closePageNotification(id: ${id}){
          ... on GeneralResponse {
            success
          }
          ... on OperationError{
            errors{
              message
              field
            }
          }
        }
      }`).pipe(
      switchMap(response => {
        const data = response['data']['closePageNotification'];

        if (data['errors']) {
          return throwError(data);
        }

        return of(data);
      }),
      this.api.unifyErrors()
    );
  }
}
